import { memo } from "react";
import { Link, generatePath } from "react-router";

import { PATHS } from "@/routes/paths";

type Props = {
	hotelID: string;
};

export const ContactListEmptyState = memo(({ hotelID }: Props) => {
	const newContactPagePath = generatePath(PATHS.HOTEL.CONTACT.NEW, { hotelID });

	return (
		<div className="space-y-4">
			<p>過去の問い合わせはまだありません</p>

			{newContactPagePath && (
				<div className="flex gap-x-2">
					<Link
						to={newContactPagePath}
						target="_blank"
						className="text-link-400 underline-offset-4 hover:underline"
						viewTransition
					>
						こちら
					</Link>
					<p>からお問い合わせください</p>
				</div>
			)}
		</div>
	);
});

ContactListEmptyState.displayName = "ContactListEmptyState";
